import { Marker, PositionedMarker } from "../../types/marker";
import { MarkersContext } from ".";
import { useDelayedState } from "../../hooks/useDelayedState";
import { useSeekBar } from "../SeekBar";
import { useEffect, useMemo, useState } from "react";
import { useRange } from "../Range";

export interface MarkersProps {
  children?: React.ReactNode;
  markers?: Marker[];
  transitionDelay?: number;
}

export const MarkersProvider = ({
  children,
  markers,
  transitionDelay,
}: MarkersProps) => {
  const { width } = useSeekBar();
  const { adjustedDuration, currentTimeOffset } = useRange();
  const originalMarkers = useDelayedState(markers, transitionDelay);
  const [positionedMarkers, setPositionedMarkers] = useState<
    PositionedMarker[]
  >([]);

  useEffect(() => {
    const newMarkers =
      originalMarkers
        ?.filter(
          (marker) => marker.time <= currentTimeOffset + adjustedDuration
        )
        .map((marker) => ({
          ...marker,
          offset:
            width * ((marker.time - currentTimeOffset) / adjustedDuration),
        })) ?? [];

    setPositionedMarkers(newMarkers);
  }, [adjustedDuration, currentTimeOffset, originalMarkers, width]);

  const value = useMemo(
    () => ({ markers: positionedMarkers }),
    [positionedMarkers]
  );

  return (
    <MarkersContext.Provider value={value}>{children}</MarkersContext.Provider>
  );
};
